import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApiService from "../../api/ApiServices";
import { AppPaths } from "../../utils/AppPaths";
import { FontWeights } from "../../utils/font.utils";

type RewardClaimedLocationState = {
	prizeTitle?: string;
	prizeImage?: string;
	pointsRequired?: number;
	message?: string;
};

const RewardClaimed = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const state = (location.state || {}) as RewardClaimedLocationState;
	const [userEmail, setUserEmail] = useState<string>("");

	useEffect(() => {
		const fetchUserEmail = async () => {
			try {
				const response = await ApiService.getUserProfile();
				const email = response?.data?.user?.email || response?.data?.email || "";
				setUserEmail(email);
			} catch {
				setUserEmail("");
			}
		};

		fetchUserEmail();
	}, []);

	const prizeTitle = state.prizeTitle || "Reward";
	const prizeImage = require("../../assets/claim_success.png");
	const inboxText = userEmail || "your registered email";

	return (
		<div className="min-h-screen px-5 pb-10">
			<div className="flex items-center relative px-1 py-4">
				<img
					onClick={() => navigate(AppPaths.PRIZES)}
					alt="Back"
					className="home-frag-pic-backbtn mr-2 cursor-pointer"
					src={require("../../assets/arrow-left.png")}
				/>
				<div className="btn-onb4-text absolute left-1/2 -translate-x-1/2 text-center">Reward Claimed</div>
			</div>

			<div className="pt-6 flex justify-center">
				<div className="w-[220px] h-[220px] flex items-center justify-center">
					<img src={prizeImage} alt={prizeTitle} className="max-w-full max-h-full object-contain" />
				</div>
			</div>

			<div className="text-center inter-regular-14 mt-4" style={{ fontWeight: 500 }}>
				Your <span style={{fontWeight: "bold"}}>{prizeTitle}</span>  is on its way!
			</div>
			<div className="text-center inter-regular-14 leading-5 mt-2" style={{ fontWeight: 500 }}>
				It will arrive in your email <span className="text-[#F73294]">{inboxText}</span> within 3-5 days. Complete more challenges to unlock even bigger rewards!
			</div>

			<div className="mt-4 justify-center flex">
				<button
					type="button"
					onClick={() => navigate(AppPaths.PRIZES, { replace: true })}
					className="primary-btn w-full cursor-pointer welcome-prize-btn"
				>
					<div className="primary-btn-text" style={{ fontSize: "14px", fontWeight: 600 }}>DONE</div>
				</button>
			</div>
		</div>
	);
};

export default RewardClaimed;
